import { Review } from '@prisma/client';
import { convertImageIDToURL } from '../lib/apis/image';
import { imageSizes } from '../data/constants';

export const getItemHeaderData = (item: any) => {
  const {
    slug,
    plan,
    country,
    city,
    images,
    name,
    location,
    location_id,
    memberships,
    reviews,
  } = item;

  const { rating, rateCnt } = getItemRating(reviews);

  return {
    ...location,
    slug,
    country,
    city,
    plan,
    name,
    rating,
    rateCnt,
    location_id,
    memberships,
    logo: (images || [])
      .filter((img: any) => img.type === 'LOGO')
      .map((el: any, i: number) => ({
        ...el,
        url: convertImageIDToURL(el.image_id, imageSizes.logo),
      }))[0],
  };
};

export const getItemGalleryData = (item: any, access?: boolean | undefined) => {
  const { plan, images } = item;
  const maxImages = [
    'TRIAL_PLATINUM',
    'PLATINUM',
    'GOLD',
    'ONECITY',
    'FIVECITIES',
    'TENCITIES',
    'TWENTYCITIES',
    'THIRTYCITIES',
  ].some((str) => str === plan)
    ? 10
    : 1;
  return (images || [])
    .filter((img: any) => img.type === 'GALLERY')
    .slice(0, access ? 10 : maxImages)
    .map((el: any, i: number) => ({
      ...el,
      hidden: i > maxImages - 1,
      small: convertImageIDToURL(el.image_id, imageSizes.s),
      large: convertImageIDToURL(el.image_id, imageSizes.xxl),
    }))
    .filter((img: any) => access || !img.hidden);
};

export const getItemRating = (reviews: Array<Review> = []) => {
  if (!reviews.length) {
    return {
      rating: 0,
      rateCnt: 0,
    };
  }
  const allKeys = Object.keys(reviews[0]);
  const ratedKeys = allKeys.filter((key) =>
    reviews.some(
      (review: any) => typeof (review[key] === 'number') && review[key] > 0
    )
  );
  const ratedReviewKeys = (review: any) =>
    allKeys.filter(
      (key) => typeof (review[key] === 'number') && review[key] > 0
    ).length;

  const allRatedReviewKeys = reviews.reduce(
    (acc, curr) => acc + ratedReviewKeys(curr),
    0
  );

  const ratedReviews = reviews.filter(
    (review) => ratedReviewKeys(review) > 0
  ).length;

  const overall =
    reviews.reduce((acc: number, curr: any) => {
      return acc + ratedKeys.reduce((acc2, curr2) => acc2 + curr[curr2], 0);
    }, 0) / allRatedReviewKeys;
  return {
    rating: isNaN(overall) ? 0 : overall.toFixed(1),
    rateCnt: ratedReviews,
  };
};

export const getReviewRating = (review: Review) => {
  const rateKeys = Object.keys(review).filter(
    (key) => typeof (review as any)[key] === 'number'
  ) as [];
  const rating =
    rateKeys.reduce(
      (acc: number, curr: keyof Review) => acc + (review[curr] as number),
      0
    ) / rateKeys.length;
  return rating;
};
